import { useLingui } from "@lingui/react/macro";
import { List, Text, Title } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { DocHeading } from "@/components/docs/DocHeading.tsx";
import { DocsContent } from "@/components/docs/DocsContent.tsx";

export const Route = createFileRoute("/docs/data-use/traceability")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useLingui();

  return (
    <DocsContent>
      <Title order={1} size="h2">{t`Auditing and traceability`}</Title>
      <Text>
        {t`REALity records requests made to the underlying data sources. This is a normal and necessary part of providing licensed official data in a controlled business environment.`}
      </Text>

      <DocHeading
        order={2}
        size="h3"
      >{t`Why requests are recorded`}</DocHeading>
      <List withPadding>
        <List.Item>{t`Cost allocation.`}</List.Item>
        <List.Item>{t`Follow-up of usage.`}</List.Item>
        <List.Item>{t`Compliance with data-provider conditions.`}</List.Item>
        <List.Item>{t`Investigation of technical problems.`}</List.Item>
        <List.Item>{t`Auditing.`}</List.Item>
        <List.Item>{t`Identification of unusual or incorrect usage.`}</List.Item>
        <List.Item>{t`Service improvement.`}</List.Item>
      </List>

      <DocHeading order={2} size="h3">{t`What is recorded?`}</DocHeading>
      <Text>{t`A request may be associated with information such as:`}</Text>
      <List withPadding>
        <List.Item>{t`The user.`}</List.Item>
        <List.Item>{t`The assignment.`}</List.Item>
        <List.Item>{t`The time of the request.`}</List.Item>
        <List.Item>{t`The requested dataset.`}</List.Item>
        <List.Item>{t`The underlying service.`}</List.Item>
        <List.Item>{t`The result or transaction type.`}</List.Item>
      </List>
    </DocsContent>
  );
}
